var symphony = symphony || {};

;(function() {

	symphony.parseEvents = function() {

		var today = moment();
		var eventListExpiration = moment().add(1, 'years');
		var tempArray = [];
		var tempEvent = {};

		symphony.revisedEvents = [];
		symphony.revisedFeaturedEvents = [];
		symphony.eventsList = [];

		var getEvents = $.get('/' + siteUrlAlias + '/events/json?start=0&limit=250&random=' + (new Date().getUTCMilliseconds()));

		getEvents.done(function(data){
			symphony.eventsList = JSON.parse(data);

			_.each(symphony.eventsList.objects, function(eventItem, i){

				if(_.isNull(eventItem.customHeadContent) || _.isNull(JSON.parse(eventItem.customHeadContent))){
					return;
				}
				//Reset temp array in each iteration
				tempArray = [];
				
				if (eventItem.startDate && eventItem.startDate != null) {
					eventItem.startDate = eventItem.startDate.split('+')[0];
					eventItem.expiry = eventItem.expiry.split('+')[0];
					if(!eventItem.published) {
						return;
					}

					eventItem.customHeadContent = JSON.parse(eventItem.customHeadContent);

					var regex = /(<([^>]+)>)/ig;
					
					eventItem.customHeadContent.dateTimeLongSummary = eventItem.customHeadContent.dateTimeLongSummary.replace(regex, " | ");

					if(!_.isNull(eventItem.customHeadContent) && !_.isNull(eventItem.customHeadContent.frequency)){
						var frequency = eventItem.customHeadContent.frequency;
						var weekRepeatCount = eventItem.customHeadContent.weekRepeatCount || 1;
						var weekRepeatDays = eventItem.customHeadContent.weekRepeatDays || null;
						var monthRepeatType = eventItem.customHeadContent.monthRepeatType || null;
						var monthRepeatCount = eventItem.customHeadContent.monthRepeatCount || null;
					}

					if(eventItem.isRecurring) {

						var today, recurrence, startDate, endDate;
						
						today = moment();
						startDate = moment(eventItem.startDate);
						endDate = moment(eventItem.expiry);
						startDate = startDate < today ? today : startDate;

						if(frequency === "weeks" && !_.isNull(weekRepeatCount)){

							if(_.isNull(weekRepeatDays)){
								//Subtracting one week from the start date since recurrence.next() is not inclusive of the start date
								recurrence = moment().recur(startDate.subtract(1, 'weeks'), moment().add(1, 'years')).every(weekRepeatCount, frequency);
							} else {
								weekRepeatDays = JSON.parse(weekRepeatDays);
								var weekdays = [];
								$.each(weekRepeatDays, function(i, d){
									if($.inArray(d, weekdays) === -1) weekdays.push(d);
								});		
								//If weekRepeatCount > 1 then need to do recurrence differently because compound intervals are not supported
								if (weekRepeatCount > 1) {
									var weekRepeatRecurrence, repeatDay;
									//Loop through each day in weekday array and 
									$.each(weekdays, function(i, d){
										repeatDay = moment().recur(startDate.subtract(1, 'days'), moment().add(1, 'years')).every(d, "daysOfWeek").next(1, "L")[0];
										weekRepeatRecurrence = moment(repeatDay).recur().every(weekRepeatCount, frequency);
										//weekRepeatRecurrence = moment().recur(startDate.subtract(1, 'days'), endDate).every(d, "daysOfWeek").every(weekRepeatCount, frequency);
										tempArray.push(repeatDay);
										tempArray = tempArray.concat(weekRepeatRecurrence.next(15, "L"));
									});
								}	
								else {
									//Subtracting one day from the start date since recurrence.next() is not inclusive of the start date					
									recurrence = moment().recur(startDate.subtract(1, 'days'), moment().add(1, 'years')).every(weekdays, "daysOfWeek");	
								}
							}

						} else if (frequency === "months"){

							if(_.isNull(monthRepeatType)){
								//recurrence = myDate.recur().every(monthRepeatCount, frequency).startDate(today.subtract(1, 'days').format()).endDate(moment().add(6, 'months').format());
								//Subtracting one month from the start date since recurrence.next() is not inclusive of the start date
								recurrence = moment().recur(startDate.subtract(1, 'months'), moment().add(1, 'years')).every(monthRepeatCount, frequency);
							} else {
								if(monthRepeatType === "dayofweek"){
									var sd = moment(eventItem.startDate);
									var dayOfWeek = sd.format('dddd');
									var days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
									var dayIndex = _.indexOf(days, dayOfWeek);
									var totalNumberOfSpecifiedDays = 0;
									var tempArrayOfDatesInMonth = [];

									var specifiedDay = moment(sd).startOf('month').day(days[dayIndex]);
									if (specifiedDay.date() > 7) specifiedDay.add(7,'d');
									var month = specifiedDay.month();

									while(month === specifiedDay.month()){
										tempArrayOfDatesInMonth.push(specifiedDay.format('MM/DD/YYYY'));
										specifiedDay.add(7,'d');
										totalNumberOfSpecifiedDays++;
									}
									var nthDayInMonth = _.indexOf(tempArrayOfDatesInMonth, sd.format('MM/DD/YYYY'));
									//recurrence = myDate.recur().every(dayOfWeek).daysOfWeek().every(nthDayInMonth).weeksOfMonthByDay().startDate(today.subtract(1, 'days').format()).endDate(moment().add(6, 'months').format("L"));
									recurrence = moment().recur(startDate, moment().add(1, 'years')).every(dayOfWeek, "daysOfWeek").every(nthDayInMonth).weeksOfMonthByDay();
									//Manually pushing start date to temp array since recurrence.next() is not inclusive of the start date
									tempArray.push(startDate.format("L")); 
								} else {
									//recurrence = myDate.recur().every(weekRepeatCount).months().startDate(today.subtract(1, 'days').format()).endDate(moment().add(6, 'months').format());
									//Subtracting one month from the start date since recurrence.next() is not inclusive of the start date
									recurrence = moment().recur(startDate.subtract(1, 'months'), moment().add(1, 'years')).every(weekRepeatCount).months(); 
								}
							}

						} else {
							return;
						}

						if (recurrence) {
							//Bug with moment.next next will skip past end date so need to remove any dates past the end date.
							tempArray = tempArray.concat(recurrence.next(30, "L"));	
						}
						//Remove dates past the end date			
						// _.remove(tempArray, function(date){
						// 	return moment(date).isAfter(endDate);
						// });

						_(tempArray).forEach(function(value, i){
							var tempEvent = {
								"isoStart" : new Date(value).toISOString(),
								"startDate" : value,
								"expiry":moment(value).format('YYYY-MM-DD') + 'T' + moment(eventItem.expiry).format('HH:mm:ss'),
								"title": eventItem.title,
								"index" : i,
								"customUrl" : typeof eventItem.customHeadContent.registrationUrl != "undefined" ? eventItem.customHeadContent.registrationUrl : '',
								//"startTime" : moment(eventItem.startDate).format('h:mm a'),
								//"endTime" : moment(eventItem.expiry).format('h:mm a'),
								"isRecurring" : eventItem.isRecurring,
								"isFeatured" : typeof eventItem.customHeadContent.featured != "undefined" ? eventItem.customHeadContent.featured : false,
								"customHeadContent" : eventItem.customHeadContent,
								"urlAlias" : eventItem.urlAlias,
								"thumbnail" : eventItem.thumbnail,
								"headerImage" : eventItem.headerImage
							}

							if(tempEvent.isFeatured && _.findIndex(symphony.revisedFeaturedEvents, function(event){ return event.title === tempEvent.title }) === -1 ){
								symphony.revisedFeaturedEvents.push(tempEvent);
							}
								
							symphony.revisedEvents.push(tempEvent);
							
						});
					} else {

						eventItem.startDate = moment(eventItem.startDate).format('L');
						//eventItem.expiry = moment(eventItem.expiry).format('L');
						//eventItem.startTime = moment(eventItem.startDate).format('h:mm a');
						//eventItem.endTime = moment(eventItem.expiry).format('h:mm a');
						eventItem.isoStart = new Date(eventItem.startDate).toISOString();
						eventItem.isFeatured = typeof eventItem.customHeadContent.featured != "undefined" ? eventItem.customHeadContent.featured : false;
						
						if(eventItem.isFeatured){
							symphony.revisedFeaturedEvents.push(eventItem);
						} else {
							symphony.revisedEvents.push(eventItem);
						}
						
					}
					
				}

			});

			var $eventsContainer = $('.eventsList');
			_.remove(symphony.revisedEvents, function(ei){
				return moment(ei.expiry).isBefore(today);
			});

			symphony.revisedFeaturedEvents = _.orderBy(symphony.revisedFeaturedEvents, 'isoStart', 'asc');
			var featuredSort = true;
			$.each(symphony.revisedFeaturedEvents, function(i, ev) {
				if (ev.customHeadContent == null || ev.customHeadContent.idx == null) {
					featuredSort = false;
				}
			});
			if (featuredSort) {
				symphony.revisedFeaturedEvents = _.orderBy(symphony.revisedFeaturedEvents, 'customHeadContent.idx', 'asc');
			}

			$eventsContainer.empty().removeClass('loading').append(symphony.templates.eventsList({ featured: symphony.revisedFeaturedEvents, events: _.slice(_.orderBy(symphony.revisedEvents, 'isoStart', 'asc'), 0, 15 )}));

			if($('.eventsList').hasClass('col-sm-12')){

				$('.eventsList').find('.sidebar-header').addClass('u-hidden');

				if($('.eventsList > a').length == 15){
				   $('.eventsList > a:nth-child(-n+6)').wrapAll('<div class="col-sm-4"></div>');
				   $('.eventsList > a:nth-child(n+1):not(:nth-child(n+8))').wrapAll('<div class="col-sm-4"></div>');
				   $('.eventsList > a').wrapAll('<div class="col-sm-4"></div>');

				   $('.eventsList.col-sm-12').find('div[class*="col-sm"]').wrapAll('<div class="row"></div>');
				}

				if($('.eventsList > a').length < 15 && $('.eventsList > a').length > 7){
				   $('.eventsList > a:nth-child(-n+7)').wrapAll('<div class="col-sm-6"></div>');
				   $('.eventsList > a').wrapAll('<div class="col-sm-6"></div>');

				   $('.eventsList.col-sm-12').find('div[class*="col-sm"]').wrapAll('<div class="row"></div>');
				}
			}


		});


		

	};


})();